import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";

class FooterOfRent extends React.Component {
  render() {
    return (
      <ProductConsumer>
        {(value) => {
          const {
            onSaveRent,
            R_frosth,
            R_dataTable,
            R_nawe_barez,
            R_wargr,
            AddProChange,
            R_totalID,
            R_waslKrdn,
            R_waslKrdnID,
            R_total,
            dolartodinar,
            getPrint,
            R_kartonakan,
            R_search_wasl,
            R_del_dis,
            L_user,
            R_WakilQard_isChecked,
            R_joripara,
            R_dashkan,
            R_dashkanID,
            R_kamkrdnawayNrx$,
            R_paraDanID,
            R_WakilQard_getIsChecked,
            R_table,
            loading,
            R_save,
            R_wasl,
            updateSale,
            getPrintPasswordRent,
            R_open,
            openUpdate,
            R_pageminsone,
            R_pageplusone,
            R_zh_barez,
            R_paraDan$,
            R_kamkrdnawayNrxID,
            dinartodolar,
            cash,
            FIB,
            OnChangePaymentCash,
            OnChangePaymentFIB,
            OnChangePayment,
            owe,
            hideLoader,
          } = value;

          const isDollar = R_joripara === "دۆلار";
          const isDinar = R_joripara === "دینار";
          const hasSavedState = R_save || this.props.savekrdn || R_search_wasl;
          const actionDisabled = R_open || R_table;
          const printRoute = R_open ? "/rent" : "/print-rent-Arabic";
          const printPasswordRoute = R_open ? "/rent" : "/print-rent";

          const renderPaymentType = () => (
            <tr>
              <td className="f4 bg-white text-sm" style={{ fontSize: "15px" }}>
                <div className="row justify-content-around align-items-center">
                  <div className="col-4 text-center">
                    <div>کاش</div>
                    <input
                      type="checkbox"
                      autoComplete="off"
                      checked={Boolean(cash)}
                      onChange={OnChangePaymentCash}
                      style={{ width: "20px", height: "20px" }}
                    />
                  </div>
                  <div className="col-4 text-center">
                    <div>قەرز</div>
                    <input
                      type="checkbox"
                      autoComplete="off"
                      checked={Boolean(owe)}
                      onChange={OnChangePayment}
                      style={{ width: "20px", height: "20px" }}
                    />
                  </div>
                </div>
              </td>
              <th style={{ width: "40%" }} className="text-danger bg-white f4">
                :$ جۆری پارەدان
              </th>
            </tr>
          );

          const renderDollarSection = () => (
            <>
              <div className="col-4">
                <div className="col-10">
                  <table className="table" id="yusif">
                    <thead>
                      <tr className={hasSavedState ? "bg-white" : ""}>
                        <td className="text-center bg-white">
                          <NumberFormat
                            value={R_total}
                            displayType="text"
                            thousandSeparator
                            prefix="$"
                            className="f4"
                          />
                        </td>
                        <th className="text-danger f5 bg-white fk" style={{ width: "45%" }}>
                          :$ کۆی گشتی
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center">
                          <input
                            type="number"
                            disabled={Boolean(R_del_dis)}
                            name="R_dashkan"
                            onChange={AddProChange}
                            value={R_dashkan === "" ? 0 : R_dashkan}
                            style={{ padding: "8px 4px" }}
                            className={`f5 border-0 pl-4 ${hasSavedState ? "bg-white" : ""}`}
                          />
                        </td>
                        <th className="text-warning f4">:کەمکردنەوە</th>
                      </tr>
                      <tr>
                        <td className="text-center text-white">
                          <NumberFormat
                            value={R_dashkan !== 0 ? R_kamkrdnawayNrx$() : R_total}
                            displayType="text"
                            thousandSeparator
                            prefix="$"
                            className="f4"
                          />
                        </td>
                        <th className="text-warning f4">:$ پارەی ماوە</th>
                      </tr>
                      {renderPaymentType()}
                      <tr>
                        <td className="text-center">
                          <NumberFormat
                            displayType="input"
                            thousandSeparator
                            disabled={Boolean(R_del_dis)}
                            name="R_paraDan$"
                            onChange={AddProChange}
                            value={R_paraDan$}
                            style={{ padding: "8px 4px", backgroundColor: hasSavedState ? "white" : "" }}
                            className="f5 border-0 pl-4"
                          />
                        </td>
                        <th className="text-warning f4 ">:$ پارەی دراو</th>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td className="text-center bg-white">
                          <NumberFormat
                            value={R_paraDan$ !== 0 && R_paraDan$ !== "" ? R_waslKrdn() : R_kamkrdnawayNrx$()}
                            displayType="text"
                            thousandSeparator
                            prefix="$"
                            className="f4"
                          />
                        </td>
                        <th className="text-danger bg-white f5 fk">:$ پارەی نەدراو</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </>
          );

          const renderDinarSection = () => (
            <>
              <div className="col-4">
                <div className="col-10">
                  <table className="table" id="yusif">
                    <thead>
                      <tr className={hasSavedState ? "bg-white" : ""}>
                        <td className="text-center bg-white">
                          <NumberFormat
                            value={R_totalID}
                            displayType="text"
                            thousandSeparator
                            prefix="ID"
                            className="f4"
                          />
                        </td>
                        <th className="text-danger bg-white f5 fk" style={{ width: "45%" }}>
                          : کۆی گشتی
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center">
                          <input
                            type="number"
                            disabled={Boolean(R_del_dis)}
                            name="R_dashkanID"
                            onChange={AddProChange}
                            value={R_dashkanID === "" ? 0 : R_dashkanID}
                            style={{ padding: "8px 4px" }}
                            className={`f5 border-0 pl-4 ${hasSavedState ? "bg-white" : ""}`}
                          />
                        </td>
                        <th className="text-warning f4">: داشکان</th>
                      </tr>
                      <tr>
                        <td className="text-center text-white">
                          <NumberFormat
                            value={R_dashkanID !== 0 && R_dashkanID !== "" ? R_kamkrdnawayNrxID() : R_totalID}
                            displayType="text"
                            thousandSeparator
                            prefix="ID"
                            className="f4"
                          />
                        </td>
                        <th className="text-warning f4">: پارەی ماوە</th>
                      </tr>
                      <tr>
                        <td className="f4 bg-white">
                          <div className="row justify-content-start align-items-center">
                            <div className="col-4"></div>
                            <div className="col-4 text-center">
                              <div>کاش</div>
                              <input
                                type="checkbox"
                                autoComplete="off"
                                onChange={OnChangePaymentCash}
                                checked={Boolean(cash)}
                                style={{ width: "20px", height: "20px" }}
                              />
                            </div>
                            <div className="col-4 text-center">
                              <div>قەرز</div>
                              <input
                                type="checkbox"
                                autoComplete="off"
                                onChange={OnChangePayment}
                                checked={Boolean(owe)}
                                style={{ width: "20px", height: "20px" }}
                              />
                            </div>
                          </div>
                        </td>
                        <th style={{ width: "40%" }} className="text-danger bg-white f4">
                          :$ جۆری پارەدان
                        </th>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <NumberFormat
                            disabled={Boolean(R_del_dis)}
                            name="R_paraDanID"
                            onChange={AddProChange}
                            value={R_paraDanID}
                            style={{ padding: "8px 4px" }}
                            className={`border-0 f5 pl-4 ${hasSavedState ? "bg-white" : ""}`}
                            displayType="input"
                            thousandSeparator
                          />
                        </td>
                        <th className="text-warning f4">: پارەی دراو</th>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td className="text-center bg-white">
                          <NumberFormat
                            value={R_paraDanID !== 0 && R_paraDanID !== "" ? R_waslKrdnID() : R_kamkrdnawayNrxID()}
                            displayType="text"
                            thousandSeparator
                            prefix="ID"
                            className="f4"
                          />
                        </td>
                        <th className="text-danger bg-white f5 fk">: پارەی نەدراو</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </>
          );

          const renderControls = () => (
            <div className="col-1 mt-2">
              <div className="card p-2 border-0 bg-white" style={{ transform: "scale(0.92)", transformOrigin: "top right" }}>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  {/* <h4 className="mb-0 text-center w-100">{R_kartonakan}</h4> */}
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <button
                    className="btn btn-dark btn-sm px-2 py-1"
                    disabled={actionDisabled}
                    onClick={R_pageminsone}
                    style={{ backgroundColor: "#00695c", border: "1px solid #00695c" }}
                  >
                    <i className="fas fa-caret-left" style={{ fontSize: "0.95rem" }}></i>
                  </button>
                  <button
                    className="btn btn-dark btn-sm px-2 py-1"
                    disabled={actionDisabled}
                    onClick={R_pageplusone}
                    style={{ backgroundColor: "#00695c", border: "1px solid #00695c" }}
                  >
                    <i className="fas fa-caret-right" style={{ fontSize: "0.95rem" }}></i>
                  </button>
                </div>
                {hasSavedState && (
                  <Link to={printRoute} className="d-inline-block w-100">
                    <button
                      type="button"
                      onClick={(e) => getPrint(R_zh_barez, e)}
                      disabled={R_open}
                      className="btn btn-info w-100 btn-sm"
                      style={{ backgroundColor: "#9900ff", border: "1px solid #9900ff", padding: "6px 8px" }}
                    >
                      <i className="fas fa-print white" style={{ fontSize: "0.95rem" }}></i>
                    </button>
                  </Link>
                )}
              </div>
            </div>
          );

          const renderActionButtons = () => (
            <div className="justify-content-center col-1 mt-2">
              <div className="row">
                <div className="btn-group ml2 col-12">
                  {R_search_wasl !== null ? (
                    <>
                      <Link to={printPasswordRoute}>
                        <button
                          type="button"
                          disabled={R_open}
                          onClick={(e) => getPrintPasswordRent(R_zh_barez, e)}
                          className="btn btn-info mr-1"
                          style={{ backgroundColor: "#9900ff", border: "1px solid #9900ff" }}
                        >
                          <i className="fas fa-print white fa-lg" />
                        </button>
                      </Link>
                      <button
                        onClick={(e) => {
                          R_open
                            ? updateSale(R_zh_barez, R_wasl._id, e)
                            : openUpdate(R_wasl.numberOfWakil, L_user._id, e, R_wasl._id);
                          this.props.onNewPage();
                        }}
                        className={`btn ${R_open ? "btn-primary" : "btn-warning"}`}
                        style={{ backgroundColor: R_open ? "navy" : "silver", border: R_open ? "1px solid navy" : "1px solid silver" }}
                      >
                        <i className={`fas ${R_open ? "fa-edit" : "fa-lock"}`} />
                      </button>
                    </>
                  ) : hasSavedState ? (
                    <>
                      <button
                        onClick={(e) => {
                          R_open
                            ? updateSale(R_zh_barez, R_wasl._id, e)
                            : openUpdate(R_wasl.numberOfWakil, L_user._id, e, R_wasl._id);
                          this.props.onNewPage();
                        }}
                        disabled={!hasSavedState}
                        className={`btn ${R_open ? "btn-primary" : "btn-warning"}`}
                        style={{ backgroundColor: R_open ? "navy" : "silver", border: R_open ? "1px solid navy" : "1px solid silver" }}
                      >
                        <i className={`fas ${R_open ? "fa-edit" : "fa-lock"}`} />
                      </button>
                      <Link to={printPasswordRoute}>
                        <button
                          type="button"
                          onClick={(e) => getPrint(R_zh_barez, e)}
                          disabled={R_open}
                          className="btn btn-info"
                          style={{ backgroundColor: "#9900ff", border: "1px solid #9900ff" }}
                        >
                          <i className="fas fa-print fa-lg white" />
                        </button>
                      </Link>
                    </>
                  ) : loading ? (
                    <button type="button" onDoubleClick={hideLoader} className="btn btn-success">
                      <i className="fas fa-spinner animate__animated animate__rotateIn animate__infinite" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={(e) =>
                        this.props.onSaveChange(R_frosth, R_dataTable, R_nawe_barez, R_wargr, R_zh_barez, onSaveRent, cash, FIB, owe, e)
                      }
                      className="btn btn-success"
                    >
                      <i className="far fa-save fa-lg" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          );

          return (
            <div className="row">
              {isDollar && renderDollarSection()}
              {isDinar && renderDinarSection()}
              {renderControls()}
              {renderActionButtons()}
              <div className="col-2 mt-2">
                <div className="form-check">
                  <input
                    onChange={R_WakilQard_getIsChecked}
                    checked={Boolean(R_WakilQard_isChecked)}
                    className="form-check-input mt-2"
                    style={{ width: "20px", height: "20px", marginRight: "10px" }}
                    type="checkbox"
                  />
                  <label className="form-check-label border border-warning rounded px-2 bg-warning font-weight-bold f4 ml-3">
                    :قەرزی پێشوو
                  </label>
                </div>
              </div>
            </div>
          );
        }}
      </ProductConsumer>
    );
  }
}

export default FooterOfRent;
